import React from "react";
import { createUseStyles } from "react-jss";
import { AccordionItem } from "Components/Accordion";

import styles from "./styles";

interface PhotoMedia {
  id: number;
  url?: string;
  smallurl?: string;
  title?: string;
  description?: string;
  network?: string;
}

interface Props {
  photos: PhotoMedia[] | undefined;
  id: string;
  title: string;
}

// This component is used to display Photos and (Panoramas as images)
const ADADestinationPhotos = (props: Props) => {
  const { photos, id, title } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  if (photos === undefined || photos.length === 0) {
    return null;
  }

  return (
    <AccordionItem id={id} title={title} headingLevel={4}>
      {photos.map((photo) => (
        <React.Fragment key={photo.id}>
          <h5 className={classes.photoHeading}>{photo.title}</h5>
          <figure className={classes.figure}>
            {photo.network === "instagram" ? (
              <iframe
                src={`https://www.instagram.com/p/${photo.url}/embed`}
                className={classes.instagramPhoto}
                frameBorder="0"
                scrolling="true"
                title={photo.title}
              />
            ) : (
              <img
                className={classes.photo}
                src={photo.smallurl}
                alt={photo.title}
              />
            )}
            {photo.description ? (
              <figcaption className={classes.photoDescription}>
                {photo.description}
              </figcaption>
            ) : null}
          </figure>
        </React.Fragment>
      ))}
    </AccordionItem>
  );
};

export default ADADestinationPhotos;
try {
    // @ts-ignore
    ADADestinationPhotos.displayName = "ADADestinationPhotos";
    // @ts-ignore
    ADADestinationPhotos.__docgenInfo = { "description": "", "displayName": "ADADestinationPhotos", "props": { "photos": { "defaultValue": null, "description": "", "name": "photos", "required": true, "type": { "name": "PhotoMedia[]" } }, "id": { "defaultValue": null, "description": "", "name": "id", "required": true, "type": { "name": "string" } }, "title": { "defaultValue": null, "description": "", "name": "title", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ADADestinationPhotos/ADADestinationPhotos.tsx#ADADestinationPhotos"] = { docgenInfo: ADADestinationPhotos.__docgenInfo, name: "ADADestinationPhotos", path: "src/shared/components/ADADestinationPhotos/ADADestinationPhotos.tsx#ADADestinationPhotos" };
}
catch (__react_docgen_typescript_loader_error) { }